"use client";
import { createContext, type PropsWithChildren, useContext } from "react";
import { type SiteAnalyticsType } from "@/types/site-analytics";

const defaultSiteAnalytics = {} as SiteAnalyticsType;

export const SiteAnalyticsContext =
  createContext<SiteAnalyticsType>(defaultSiteAnalytics);

export function SiteAnalyticsProvider(
  props: PropsWithChildren<{ value: SiteAnalyticsType }>,
) {
  const { value, children } = props;

  return (
    <SiteAnalyticsContext.Provider value={value}>
      {children}
    </SiteAnalyticsContext.Provider>
  );
}

export function useSiteAnalyticsContext() {
  return useContext(SiteAnalyticsContext);
}
